import styled from 'styled-components';
import { Flex } from '../../../GlobalComponents/Flex';

export type TotalsProps = {
	subTotal: JSX.Element | string;
	taxAmount: JSX.Element | string;
	total: JSX.Element | string;
};

export const Totals: React.FC<TotalsProps> = ({
	subTotal,
	taxAmount,
	total
}) => (
	<Flex $flexDirection="column" $rowGap="6px" $height="auto">
		<Flex $flexDirection="row" $placeContent="center space-between">
			<Title>Subtotal</Title>
			<Amount>${subTotal}</Amount>
		</Flex>
		<Flex $flexDirection="row" $placeContent="center space-between">
			<Title>Tax</Title>
			<Amount>${taxAmount}</Amount>
		</Flex>
		<Flex $flexDirection="row" $placeContent="center space-between">
			<Title>Total</Title>
			<Amount>${total}</Amount>
		</Flex>
	</Flex>
);

const Title = styled.div`
	font-weight: 500;
	font-size: 20px;
	color: #222222;
`;

const Amount = styled.div`
	font-weight: 500;
	font-size: 20px;
	color: #575757;
`;
